<template>
  <div>
    <title-products title="Produtos"></title-products>
    <view-products></view-products>
    <open-edit-product></open-edit-product>
    <open-delete-product></open-delete-product>
    <open-add-product></open-add-product>
  </div>
</template>

<script>
import Title from "../geral/Title";
import ViewProducts from "./product/ViewProducts";
import OpenEditProduct from "./tools/OpenEditProduct";
import OpenDeleteProduct from "./tools/OpenDeleteProduct";
import OpenAddProduct from "./tools/OpenAddProduct";
export default {
  name: "Products",
  components: {
    OpenAddProduct,
    OpenDeleteProduct,
    OpenEditProduct,
    ViewProducts,
    "title-products": Title
  }
};
</script>

<style scoped></style>
